import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { deleteAdminLoading: true, deleteAdminMessage: '', deleteAdminError: false };

export function deleteOrganisationAdmins(state = initialState, action) {
  switch (action.type) {
    case organisationConstants.REQUEST_DELETE_ADMIN_ORG:
      return {
        deleteAdminLoading: true,
        deleteAdminMessage: '',
        deleteAdminError: false,
        payload: action.payload
    };
    case organisationConstants.RESPONSE_DELETE_ADMIN_ORG:
      return {
        deleteAdminLoading: false,
        deleteAdminMessage: action.removed,
        deleteAdminError: false
      };
    case organisationConstants.ERROR_DELETE_ADMIN_ORG:
      return {
        deleteAdminLoading: false,
        deleteAdminMessage: '',
        deleteAdminError: true
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/deleteOrgAdmin.reducer.js